import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Rentabusinshrigonda() {



  const cardData =
  {
    keyword: 'Rent a Bus in Shrigonda',
    heading: 'Sanavi Travels: Rent a Bus in Shrigonda',
    headingDescription: 'Sanavi Travels makes it easy to rent a bus in Shrigonda, offering safe, comfortable, and affordable transportation for families, groups, corporate travel, school trips, weddings, picnics, religious tours, and outstation journeys. Our fleet includes well-maintained AC and Non-AC buses, mini buses, and luxury coaches designed for smooth rides, spacious seating, and ample luggage capacity. With experienced drivers, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, renting a bus in Shrigonda is ideal for local travel, sightseeing tours, and long-distance trips. Choose Sanavi Travels for reliable bus rental services in Shrigonda, ensuring comfort, safety, and a stress-free travel experience every time.',

    top: 'Top Places to Visit in Shrigonda with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shrigonda Town",
    "description": "Shrigonda is a taluka in Ahmednagar district, Maharashtra, known for its agricultural significance and scenic surroundings. Situated amidst fertile plains and gentle hills, Shrigonda offers a glimpse into rural Maharashtrian life, traditional farming practices, and local culture. The town is a blend of history, spirituality, and natural beauty, making it an offbeat destination for travelers seeking authenticity."
  },
  {
    "title": "Shri Khandoba Temple",
    "description": "Shrigonda is home to a prominent Khandoba Temple, dedicated to Lord Khandoba, an incarnation of Lord Shiva. The temple attracts devotees from nearby villages and towns, especially during festivals, and reflects traditional Maharashtrian temple architecture with intricate carvings and a serene atmosphere."
  },
  {
    "title": "Agricultural Fields and Rural Life",
    "description": "The region around Shrigonda is primarily agricultural, cultivating sugarcane, jowar, and pulses. Visitors can explore rural landscapes, interact with local farmers, and experience the simplicity of village life, along with traditional customs and festivals."
  },
  {
    "title": "Local Markets",
    "description": "Shrigonda’s local markets offer fresh produce, handicrafts, and essential goods. These bustling markets give a sense of rural commerce and provide an opportunity to experience local culinary delights and community interactions."
  },
  {
    "title": "Nearby Forts and Heritage Sites",
    "description": "The taluka is surrounded by historical forts and ruins that reflect Maratha and earlier dynasties’ heritage. Though lesser-known, these sites offer trekking, photography, and a chance to explore Maharashtra’s rich historical legacy."
  },
  {
    "title": "Temghar Ghat (Nearby)",
    "description": "Shrigonda provides access to nearby ghats and hill passes such as Temghar Ghat, offering scenic landscapes, monsoon waterfalls, and trekking opportunities. The natural beauty of these ghats attracts nature enthusiasts and adventure seekers."
  },
  {
    "title": "Festivals and Cultural Events",
    "description": "Shrigonda celebrates local festivals with devotion and enthusiasm, including Ganesh Chaturthi, Shiv Jayanti, and Khandoba Utsav. These events feature traditional music, folk dances, and communal rituals, providing visitors an authentic cultural experience."
  },
  {
    "title": "Rivers and Water Bodies",
    "description": "Small rivers and streams flow through Shrigonda, contributing to agriculture and natural beauty. These water bodies become especially scenic during the monsoon, offering calm spots for relaxation and photography."
  },
  {
    "title": "Village Temples and Spiritual Sites",
    "description": "Apart from the main Khandoba temple, Shrigonda taluka has numerous small village shrines and temples dedicated to local deities. These sites reflect traditional faith practices and offer peaceful spiritual retreats for devotees and travelers."
  },
  {
    "title": "Eco-Tourism and Nature Trails",
    "description": "Shrigonda’s rural landscapes, hills, and forests provide opportunities for eco-tourism, trekking, and nature trails. Visitors can enjoy birdwatching, exploring local flora and fauna, and experiencing the serene countryside."
  }
]
,



"services": [
{
"name": "Rent a Bus in Shrigonda",
"description": "Rent a Bus in Shrigonda offers dependable and comfortable bus rental solutions for all types of group travel requirements. Whether it is for family functions, weddings, corporate events, school trips, or tourist outings, this service ensures spacious seating, clean interiors, and smooth travel. With experienced drivers and well-maintained buses, passengers can enjoy a safe, punctual, and stress-free journey for both local and outstation routes."
},
{
"name": "Bus Hire Shrigonda",
"description": "Bus Hire Shrigonda provides easy and flexible bus hiring services suitable for small and large groups. Ideal for weddings, corporate travel, religious tours, and social events, this service focuses on timely pickups, professional chauffeurs, and reliable travel arrangements. It is designed to make group transportation convenient, organized, and comfortable across Shrigonda and nearby destinations."
},
{
"name": "AC Bus Shrigonda",
"description": "AC Bus Shrigonda ensures a cool and comfortable travel experience with fully air-conditioned buses. Perfect for long-distance journeys, summer travel, corporate outings, and family trips, these buses offer relaxed seating, smooth rides, and professional drivers, allowing passengers to travel comfortably regardless of weather conditions."
},
{
"name": "Luxury Bus Shrigonda",
"description": "Luxury Bus Shrigonda delivers a premium travel experience with elegant interiors, pushback seats, and modern amenities. Ideal for weddings, VIP guests, corporate events, and special occasions, this service combines comfort, style, and safety, making every journey pleasant, memorable, and hassle-free."
},
{
"name": "Wedding Bus Shrigonda",
"description": "Wedding Bus Shrigonda provides organized and comfortable transportation for wedding guests and family members. With spacious buses, professional drivers, and punctual service, it ensures smooth coordination of guest travel between venues, helping wedding events run seamlessly and without transportation worries."
},
{
"name": "Corporate Bus Shrigonda",
"description": "Corporate Bus Shrigonda offers reliable transport solutions for employee travel, corporate meetings, office outings, and business events. Designed for efficiency and comfort, these buses feature experienced chauffeurs, timely service, and comfortable seating, ensuring professional and stress-free corporate transportation."
},
{
"name": "Outstation Bus Shrigonda",
"description": "Outstation Bus Shrigonda provides safe and comfortable long-distance bus travel for families, groups, and organizations. Suitable for pilgrimages, weekend getaways, tours, and intercity journeys, this service ensures well-maintained buses, skilled drivers, and a smooth travel experience over longer routes."
},
{
"name": "Affordable Bus Shrigonda",
"description": "Affordable Bus Shrigonda offers cost-effective bus rental services without compromising on safety or comfort. Ideal for budget-conscious travelers, families, and group trips, this service provides transparent pricing, reliable vehicles, and professional drivers, making group travel economical and convenient."
},
{
"name": "Chauffeur Driven Bus Shrigonda",
"description": "Chauffeur Driven Bus Shrigonda ensures a relaxed and hassle-free journey with trained drivers managing routes, traffic, and schedules. Perfect for weddings, corporate events, tours, and family trips, this service focuses on passenger safety, punctuality, and smooth travel experiences."
},
{
"name": "Best Bus Rent Shrigonda",
"description": "Best Bus Rent Shrigonda is known for quality service, clean buses, and dependable travel solutions. Suitable for weddings, corporate functions, sightseeing tours, and outstation travel, it prioritizes customer satisfaction, safety standards, and timely transportation for all group travel needs."
},
{
"name": "Tourist Bus Shrigonda",
"description": "Tourist Bus Shrigonda caters to travelers exploring Shrigonda and nearby attractions. With comfortable seating, flexible itineraries, and experienced drivers, it provides a pleasant sightseeing and tour experience for families, groups, and tourists seeking convenient and enjoyable travel."
},
{
"name": "Group Travel Bus Shrigonda",
"description": "Group Travel Bus Shrigonda offers organized transportation for friends, families, corporate teams, and tour groups. Spacious buses, professional chauffeurs, and coordinated scheduling ensure smooth, safe, and comfortable journeys, making group travel simple and well-managed."
},
{
"name": "Online Bus Booking Shrigonda",
"description": "Online Bus Booking Shrigonda allows customers to easily book buses with quick confirmation and flexible travel options. With multiple bus choices and simple booking processes, it helps travelers plan weddings, events, tours, and group trips efficiently and conveniently."
},
{
"name": "Event Bus Shrigonda",
"description": "Event Bus Shrigonda provides dedicated transportation services for weddings, corporate gatherings, social functions, and special events. With reliable buses, punctual service, and experienced drivers, it ensures smooth movement of guests and participants throughout the event."
},
{
"name": "Shrigonda Travel Bus",
"description": "Shrigonda Travel Bus offers complete bus travel solutions for local trips, outstation journeys, events, weddings, and corporate travel. With well-maintained vehicles, skilled chauffeurs, and customer-focused service, it guarantees safe, comfortable, and hassle-free group transportation."
}
],
"tableData": [
["Rent a Bus in Shrigonda", "Bus Hire Shrigonda"],
["AC Bus Shrigonda", "Luxury Bus Shrigonda"],
["Wedding Bus Shrigonda", "Corporate Bus Shrigonda"],
["Outstation Bus Shrigonda", "Affordable Bus Shrigonda"],
["Chauffeur Driven Bus Shrigonda", "Best Bus Rent Shrigonda"],
["Tourist Bus Shrigonda", "Group Travel Bus Shrigonda"],
["Online Bus Booking Shrigonda", "Event Bus Shrigonda"],
["Shrigonda Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Rent a Bus in Shrigonda with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Shrigonda, perfect for group outings, family trips, school tours, corporate travel, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Shrigonda and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with routes in and around Shrigonda, ensuring safe, punctual, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Shrigonda, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Shrigonda."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Shrigonda."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Shrigonda?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Shrigonda for various travel needs.'
  },
  {
    question: 'How can I rent a bus in Shrigonda?',
    answer: 'You can easily rent a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Shrigonda?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Shrigonda?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Shrigonda routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Shrigonda?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Shrigonda and nearby areas.'
  },
  {
    question: 'Is the bus rental service in Shrigonda available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Shrigonda to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Shrigonda.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prashant Patil',
    feedback: 'We rented a bus in Shrigonda with Sanavi Travels — very comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aishwarya More',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our Shrigonda trip. Highly recommended!',
    rating: 5
  }
];












































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Rent a Bus in Shrigonda - Sanavi Travels",
  "description": "Rent a bus in Shrigonda with Sanavi Travels. We provide AC and luxury buses for weddings, corporate trips, outstation tours, group travel, events, and tourist trips. Affordable and chauffeur-driven buses with easy online booking.",
  "touristType": "Wedding, Corporate, Outstation, Group Travel, Tourist",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "20"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Rent a Bus in Shrigonda | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Rent a bus in Shrigonda with Sanavi Travels. AC and luxury buses available for weddings, corporate trips, outstation tours, group travel, and events. Affordable, chauffeur-driven, and bookable online."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/193.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Rentabusinshrigonda;